import { get } from 'lodash/fp';
import axios from './axios';

export default (jobUid, designUid) => (
  axios.post(`/jobs/${jobUid}/designs`, {
    designUid,
  })
    .then(get('data'))
);
